import { render, staticRenderFns } from "./WorldViewCreatePage.vue?vue&type=template&id=0ca7a7dd&scoped=true&"
import script from "./WorldViewCreatePage.vue?vue&type=script&lang=ts&"
export * from "./WorldViewCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./WorldViewCreatePage.vue?vue&type=style&index=0&id=0ca7a7dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7a7dd",
  null
  
)

export default component.exports